'use strict';
module.exports = Backbone.Model.extend({
    defaults: {
        initialized: false,
        passwordChanged: false,
        hasMembershipForBrand: null,
        userDTO: null,
        error: '',
        errorPsw: '',
        errorMaxLength: 50,
        errors: {
            'AUTH_000': 'loginerror',
            'VAL_002': 'incorrectformat',
            'VAL_003': 'invalid',
            'default': 'notchanged',
        },
        isActive: false,
    },

    dataUrl: 'hasMembershipForBrand',

    url: function() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(this.dataUrl);
    },

    initialize: function() {
        this.fetch({
            success: (model, value) => this.setValue(model, value),
            error: (model) => this.setValue(model, null),
        });
    },

    setValue: function(model, value) {
        return model.set({hasMembershipForBrand: value});
    },

});
